import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Link, useNavigate } from 'react-router-dom';
import { FaRegUserCircle, FaUserCircle } from "react-icons/fa";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Modal } from 'antd';
import { Nav, Navbar, NavDropdown, Container } from 'react-bootstrap';
import '../App.css'

function TitleNavbar() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElMaster, setAnchorElMaster] = useState(null);
  const [anchorElTransaction, setAnchorElTransaction] = useState(null);
  const [anchorElReport, setAnchorElReport] = useState(null);
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const role = sessionStorage.getItem('role');
  const userName = sessionStorage.getItem('userName');
  const branchName = sessionStorage.getItem('branchName');




  const showLogoutModal = () => {
    setIsLogoutModalVisible(true);
  };

  const handleLogout = () => {
    setIsLogoutModalVisible(false);
    sessionStorage.clear(); // Clear session storage
    navigate('/'); // Navigate to the login page
  };

  const handleCancelLogout = () => {
    setIsLogoutModalVisible(false);
  };
//====================================================

const navbg = {
  // background: "#2E86C1",
  // background: "-webkit-linear-gradient(to right,rgb(0, 0, 0),rgb(3, 47, 90))",
  // background: "linear-gradient(to right, rgb(0, 0, 0),rgb(3, 47, 90))",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
}

//====================================================

  return (
   

  //   <Navbar className='row m-0' collapseOnSelect expand="lg" variant="dark"  style={{maxHeight:"30px"}}>
  //   <Container className='col-12' style={{}}>
  //     <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ color: "red", }} >
  //       <MenuIcon fontSize='medium' />
  //     </Navbar.Toggle>
  //     <Navbar.Collapse id="responsive-navbar-nav">
  //     <Nav className="me-auto"></Nav>
  //       <Nav>
  //         <Nav.Link className='navtxt' href="#/dashboard">Dashboard</Nav.Link>

  //         <NavDropdown className='navtxt1' title={<span className='navtxt'>Masters</span>} id="basic-nav-dropdown"> 
  //         {role==1 && ( 
  //             <>
  //             <NavDropdown.Item className='navText1' href="#/m-1">User Master</NavDropdown.Item>
  //             <NavDropdown.Item className='navText1' href="#/m-2">Mine Master</NavDropdown.Item>
  //             </>
  //           )}           
            
  //           <NavDropdown.Item className='navText1' href="#/m-3">Product Master</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/m-4">Rate Master</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/m-5">Customer Master</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/m-6">Employee Master</NavDropdown.Item>
  //         </NavDropdown>

  //         <NavDropdown className='navtxt1' title={<span className='navtxt'>Transactions</span>} id="basic-nav-dropdown">            
  //           {role==1 && ( 
  //             <>
  //             <NavDropdown.Item className='navText1' href="#/trans-1">Assign Mine To User</NavDropdown.Item>
  //             </>
  //           )}
  //             <NavDropdown.Item className='navText1' href="#/trans-2">Billing Entry</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/trans-3">Payment Receive</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/trans-4">Expenses Entry</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/trans-5">Employee Expense</NavDropdown.Item>
  //           <NavDropdown.Item className='navText1' href="#/trans-6">Opening Balance Entry</NavDropdown.Item>
  //         </NavDropdown>

  //         <NavDropdown className='navtxt1' style={{marginRight:"60px",}} title={<span className='navtxt'>Reports</span>} id="basic-nav-dropdown">            
  //         <div className='p-0' style={{flexWrap:"nowrap",fontSize:"16px"}}>
  //               <NavDropdown.Item className='navText1' href="#/r-1">Billing Summery</NavDropdown.Item>
  //               <NavDropdown.Item className='navText1' href="#/r-2">Receipt Summery</NavDropdown.Item>
  //               <NavDropdown.Item className='navText1' href="#/r-3">Payment Pending Summery</NavDropdown.Item>
  //               <NavDropdown.Item className='navText1' href="#/r-4">Employee Expense Summery</NavDropdown.Item>
  //               <NavDropdown.Item className='navText1' href="#/r-5">Expenses Entry Summery</NavDropdown.Item>
  //               <NavDropdown.Item className='navText1' href="#/r-7">Finanacial Outcome Summery</NavDropdown.Item>
  //               {/* <NavDropdown.Item className='navText1' href="#/r-6">Payment Recieve Summery</NavDropdown.Item> */}
  //         </div>
  //         </NavDropdown>

  //         {/* <Nav.Link className='navtxt' href='#/mde001/' >Muhurta Data Entry</Nav.Link> */}

  //         {/* <Nav.Link className='navtxt fw-bolder'  onClick={() => showLogoutModal()}>Logout <ExitToAppIcon fontSize='small' /></Nav.Link> */}

  //         <NavDropdown
  //          className='navtxt1'
  //            title={ <span className='navtxt' >  <FaUserCircle size={18} style={{marginRight: "8px" }}/>{userName}</span>}
  //          id="user-nav-dropdown"
  //        style={{ marginRight: "60px"}}
  //           >
            
  //             <NavDropdown.Item  className='navText1' onClick={showLogoutModal}>
  //               Logout <ExitToAppIcon fontSize="small" style={{ marginLeft: "5px" }} />
  //             </NavDropdown.Item>
  //             <NavDropdown.Item className='navText1' href="#/pass">Change Password</NavDropdown.Item>
  //           </NavDropdown>
          
  //       </Nav>
  //     </Navbar.Collapse>
  //   </Container>

  //     {/* Logout Confirmation Modal */}
  //     <Modal
  //       title="Logout Confirmation"
  //        visible={isLogoutModalVisible}
  //      onOk={handleLogout}
  //        onCancel={handleCancelLogout}
  //        okText="Yes, Logout"
  //      cancelText="Cancel"
  //     >
  //       <Typography>Are you sure you want to logout?</Typography>
  //    </Modal>

  // </Navbar>
    <Navbar className='row m-0' collapseOnSelect expand="lg" variant="dark">
      <Container className='col-12' style={{}}>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ color: "#fff", }} >
          <MenuIcon fontSize='medium' />
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto"></Nav>
          <Nav>
            <Nav.Link className='navtxt' href="#/dashboard">Dashboard</Nav.Link>
  
            <NavDropdown className='navtxt1' title={<span className='navtxt'>Masters</span>} id="basic-nav-dropdown"> 
            {role==1 && ( 
                <>
                <NavDropdown.Item className='navText1' href="#/m-1">User Master</NavDropdown.Item>
                <NavDropdown.Item className='navText1' href="#/m-2">Mine Master</NavDropdown.Item>
                </>
              )}           
              
              <NavDropdown.Item className='navText1' href="#/m-3">Product Master</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/m-4">Rate Master</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/m-5">Customer Master</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/m-6">Employee Master</NavDropdown.Item>
            </NavDropdown>
  
            <NavDropdown className='navtxt1' title={<span className='navtxt'>Transactions</span>} id="basic-nav-dropdown">            
              {role==1 && ( 
                <>
                <NavDropdown.Item className='navText1' href="#/trans-1">Assign Mine To User</NavDropdown.Item>
                </>
              )}
                <NavDropdown.Item className='navText1' href="#/trans-2">Billing Entry</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/trans-3">Payment Receive</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/trans-4">Expenses Entry</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/trans-5">Employee Expense</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/trans-6">Opening Balance Entry</NavDropdown.Item>
            </NavDropdown>
  
            <NavDropdown className='navtxt1' style={{marginRight:"60px",}} title={<span className='navtxt'>Reports</span>} id="basic-nav-dropdown">            
            <div className='p-0' style={{flexWrap:"nowrap",fontSize:"14px"}}>
                  <NavDropdown.Item className='navText1' href="#/r-1">Billing Summery</NavDropdown.Item>
                  <NavDropdown.Item className='navText1' href="#/r-2">Receipt Summery</NavDropdown.Item>
                  <NavDropdown.Item className='navText1' href="#/r-3">Payment Pending Summery</NavDropdown.Item>
                  <NavDropdown.Item className='navText1' href="#/r-4">Employee Expense Summery</NavDropdown.Item>
                  <NavDropdown.Item className='navText1' href="#/r-5">Expenses Entry Summery</NavDropdown.Item>
                  <NavDropdown.Item className='navText1' href="#/r-7">Finanacial Outcome Summery</NavDropdown.Item>
                   <NavDropdown.Item className='navText1' href="#/r-6">Payment Receive Summery</NavDropdown.Item> 
            </div>
            </NavDropdown>
  
  
            {/* <Nav.Link className='navtxt fw-bolder'  onClick={() => showLogoutModal()}>Logout <ExitToAppIcon fontSize='small' /></Nav.Link> */}
  
            <NavDropdown
             className='navtxt1'
               title={ <span className='navtxt' >  <FaUserCircle size={18} style={{marginRight: "8px" }}/>{userName}</span>}
             id="user-nav-dropdown"
           style={{ marginRight: "60px"}}
              >
                    <NavDropdown.Item className='navText1' href="#/pass">Change Password</NavDropdown.Item>
              </NavDropdown>
            
                <NavDropdown.Item  className='navText1' onClick={showLogoutModal}>
                  Logout <ExitToAppIcon fontSize="small" style={{ marginLeft: "5px" }} />
                </NavDropdown.Item>
          
          </Nav>
        </Navbar.Collapse>
      </Container>
  
        {/* Logout Confirmation Modal */}
        <Modal
          title="Logout Confirmation"
           visible={isLogoutModalVisible}
         onOk={handleLogout}
           onCancel={handleCancelLogout}
           okText="Yes, Logout"
         cancelText="Cancel"
        >
          <Typography>Are you sure you want to logout?</Typography>
       </Modal>
  
    </Navbar>

  );
}

export default TitleNavbar;
